/* GENERATED from succession/brands/veyla/shared/vy-offer.js by
   build-listicle-theme.py. Do not edit this file: edit the shared one
   and rebuild, or this lander quietly keeps selling old prices.
   A REPRICING IS NOT DONE until this lander is rebuilt and repushed. */
/* ============================================================
   VEYLA | the offer, in one place

   Consumed by the PDP (?view=veyla-lab), the homepage (?view=veyla-home) and
   the standalone landers. Tier prices, the Seal plans, the subscribe default
   and the shape of the add-to-cart payload live here and nowhere else, so a
   repricing is one file to change and no chance of fixing one surface and
   forgetting the others.

   DOM-free on purpose. No selectors, no markup, no listeners, no side
   effects beyond defining window.VY_OFFER. That is what makes it safe to
   drop underneath a page that is already live on the client's theme.

   ------------------------------------------------------------
   REBUILT 2026-08-08. Read PDP-SOT.md before changing anything here.

   What changed and why, because it is not a tidy-up:

   Kaching Bundles used to be the pricing authority on this product. It priced
   the bundle, we sent it a line property, and the ladder worked because a
   cart function reached in and rewrote the line total. That is gone: the
   product was taken off the Kaching deal on 2026-08-08 and the cart now
   prices every line linearly, which was proved with pdp/cart-probe-ours.py
   across all six cells.

   With no cart function in play a per-unit percentage can never make two
   tubes cost the same as one, so the tiers stop being QUANTITIES of one
   variant and become VARIANTS in their own right. One variant per tier,
   quantity always 1, and a Seal selling plan whose cadence matches the tier.
   Shopify then prices the line on its own and there is no app left to
   disagree with the buybox.

   Consequences worth knowing:
     - The old COPY ladder (1/2/6 tubes, mirroring their Kaching widget) is
       deleted. It is unsellable now: no backend on this product can produce
       it. Landers that still set window.VY_SURFACE = 'copy' get this ladder
       instead, which is the correct one for the product they link to.
     - The subscribe toggle moves the price again. It has to: no selling
       plan means no discount, full stop. Omar accepted this 2026-08-08,
       omar-os #942.

   Every number below was read off the live store and verified against the
   real cart with pdp/cart-probe-ours.py. Where the store and its apps
   disagree, the CART wins: it is what the customer is charged.
   ============================================================ */
(() => {
  /* Every price string on both surfaces is built here. When the Vitals
     currency layer (vy-currency.js) has a conversion for this visitor,
     money() speaks it; otherwise plain USD. Checked at call time because
     the conversion lands seconds after first paint, and the pages listen
     for 'vy:currency' to re-render when it does. */
  const money = c =>
    (window.VY_CC && window.VY_CC.fmt(c)) || '$' + (c / 100).toFixed(2);

  /* WHICH SURFACE. There is only one now.

     There used to be two ladders, picked by sniffing the URL, and that broke
     live: the client renamed the product, the "-copy" suffix disappeared, the
     test stopped matching and the page silently served the wrong product's
     variant id at the wrong prices (omar-os #883). The fix is not a better
     regex. It is having one ladder and one product, so there is nothing to
     detect and nothing to get wrong.

     window.VY_SURFACE is still read by some landers. It is deliberately
     ignored: whatever it says, they sell this product at this ladder. Left in
     place rather than removed so those pages keep working untouched. */

  /* ----------------------------------------------------------
     The product. Ours, the one Veyla gave us for this PDP.
     NOT their live product (10896017424551 / growth-serum), which we do not
     sell and must never link to or price against mid-pitch.
     ---------------------------------------------------------- */
  const PRODUCT_ID = 11108512694439;

  /* Seal Subscriptions, dedicated rule built 2026-08-08 and scoped to this
     product alone. Three plans, 20% each, cadence matched to the tube count
     at roughly a tube a month. Ids were read off /products/....js, never
     transcribed from the admin.

     Probed against the real cart the same day: the 20% applies to the FIRST
     order on all three plans, and Shopify attaches the right plan id to the
     line. The old store wide plan 3371696295 no longer touches this product,
     and their own product still carries only that plan, unchanged. */
  const MONTHLY   = { id: 4027613351, everyDays: 30, label: 'every month' };
  const TWO_MONTH = { id: 4027646119, everyDays: 61, label: 'every 2 months' };

  const SUB = {
    pct: 20,
    /* the fallback, only reached if a tier has no plan of its own */
    plan: MONTHLY,
    /* Two plans, three tiers: the one and two tube bundles both refill
       monthly, the four tube bundle every second month. Set by the owner
       2026-08-08 (omar-os #973). */
    byTier: {
      solo: MONTHLY,
      bogo: MONTHLY,
      b2g2: TWO_MONTH
    }
  };

  /* THE LADDER, set by the brand owner 2026-08-08 (omar-os #972). One, two
     and four tubes. It replaces the 2 / 4 / 6 ladder outright: the six tube
     tier is gone, and with it the manager's old #792 instruction that prices
     had to land on $69.95 and $89.95, since $89.95 no longer exists.

     The first two tiers cost the SAME. That is the point, not an error: same
     price, twice the product, which makes the middle bar the obvious choice.
     It is the shape their own widget used.

     Bases are the one-time prices. 8744 is chosen so the 20% lands on $69.95;
     4995 gives $39.96 rather than the $39.95 in the owner's mock, because
     $39.95 / 0.8 = $49.9375 and there is no such price. See ROUNDING below.
     compareCents is always tubes x $79.95 RRP.

     ROUNDING, still unproven (omar-os #941). 8744 x 0.8 = 6995.2. subCents()
     rounds it to $69.95, and Shopify is expected to do the same, but the
     variants are tracked at zero stock so /cart/add.js refuses them and the
     probe has not been able to run (#974). Until it does, $69.95 is an
     expectation, not a fact, and nothing ships on an expectation.

     variantId ids read off /products/....js on 2026-08-08, never transcribed
     from the admin. Note these are NEW ids: adding the Bundle option made
     Shopify create three fresh variants rather than rename the original, so
     the old single variant 51104449822887 no longer exists. */
  const TIERS = {
    solo: { tubes: 1, variantId: 51130200785063, totalCents: 4995, compareCents: 7995,  label: 'Buy 1',
            cardTitle: 'Buy 1',             cardSub: '1 tube · starter plan',                flag: '' },
    bogo: { tubes: 2, variantId: 51130200817831, totalCents: 4995, compareCents: 15990, label: 'Buy 1 Get 1 Free',
            cardTitle: 'Buy 1 Get 1 FREE',  cardSub: '2 tubes · visible results',            flag: 'Most popular' },
    b2g2: { tubes: 4, variantId: 51130200850599, totalCents: 8744, compareCents: 31980, label: 'Buy 2 Get 2 Free',
            cardTitle: 'Buy 2 Get 2 FREE',  cardSub: '4 tubes · complete hair restoration',  flag: 'Biggest savings' }
  };

  /* Cheapest to dearest. Anything that needs to reason about position reads
     this rather than naming a key, because the keys have already changed once
     (b1g1/b2g2/b3g3 meant 2/4/6 tubes, which stopped being true on
     2026-08-08 and would have quietly mislabelled every tier). */
  const TIER_ORDER = ['solo', 'bogo', 'b2g2'];

  /* The ladder opens on the two tube offer, per the owner's mock: it carries
     MOST POPULAR and is preselected. Shared by the PDP and the homepage, so
     both surfaces move together. */
  const TIER_DEFAULT = 'bogo';

  const SERUM = { rrpCents: 7995 };
  const SUB_ENABLED = true;

  /* SUBSCRIBE STARTS ON (Osama, 2026-08-03). Still true, and now it is also
     honest: subscribing is what buys the 20%. */
  const SUB_DEFAULT = true;

  /* Whether the sub terms line may name an AMOUNT as well as a cadence.
     Still off. With variants the renewal price should simply be the variant's
     own price less 20%, since no cart function is involved any more and Seal
     carries the whole discount. That reasoning is sound but it is reasoning,
     not evidence, and a renewal cannot be probed from the cart. Flip this to
     true once a real Seal contract or a real renewal order has been read in
     the admin (omar-os #855). Until then: cadence only, never an amount. */
  const SUB_TERMS_PRICE = false;

  const PRODUCT_URL = '/products/veyla%E2%84%A2-hair-growth-serum';

  /* Thinning zone. Cosmetic only: it aims the routine copy and labels the
     cart line so support knows where she is treating. No variant changes,
     because the variants are bundle sizes, not zones. */
  const ZONES = {
    hairline: { label: 'Hairline', dot: '#DE5504',
      note: 'Temples and the front edge respond first, because they go dormant first. Press along the edge and work back two inches.' },
    part:     { label: 'Part line', dot: '#C2410C',
      note: 'Run the brush straight down the part, then make a second part an inch over and do that one too. Widening starts at the edges.' },
    crown:    { label: 'Crown', dot: '#9A3412',
      note: 'The hardest spot to see and the easiest to under-treat. Use a mirror for the first week until your hand knows where it is.' },
    overall:  { label: 'All over', dot: '#EA7B2E',
      note: 'Four passes: hairline, part, crown, then the sides. One tube still covers a month, because it is one minute, not ten pumps.' }
  };
  const ZONE_DEFAULT = 'hairline';

  const planFor  = key => SUB.byTier[key] || SUB.plan;
  const subCents = c => Math.round(c * (100 - SUB.pct) / 100);

  /* Both surfaces hold their own { zone, tier, sub } state object and hand it
     in here, rather than this module holding state that two pages would then
     have to keep in sync.

     THE TOGGLE MOVES THE PRICE (Omar, 2026-08-08, #942). One time is the
     variant's own price; subscribed is that less 20%, which is what the Seal
     plan actually does to the line. The previous rule applied the 20% in both
     modes, and that only ever worked because Kaching was pricing the cart.
     With Seal alone, no plan means no discount, so showing a discounted
     one-time price would be advertising under what the cart charges. */
  const tierTotal = (tierKey, sub) => {
    const t = TIERS[tierKey];
    return sub ? subCents(t.totalCents) : t.totalCents;
  };

  const tubeWord = n => `${n} tube${n === 1 ? '' : 's'}`;

  /* The delivery frequency, per tier, short enough to sit on a bundle card.
     Each tier is on its own Seal plan, so the cadence is a REASON to pick one
     bar over another and the cards have to say it. Before this the page named
     a cadence once, under the switch, for whichever bar happened to be
     selected: she could not compare them without clicking each one. */
  const shipEvery = tierKey => `Refills ${planFor(tierKey).label}`;

  /* The line under the buybox while subscribe is on. Concrete rather than
     abstract: what arrives now, what arrives next, and how often. "Refills
     land every month" made her do the arithmetic; naming the tube count both
     times means she knows exactly what she signed up for.

     It still names no AMOUNT until SUB_TERMS_PRICE says the renewal price has
     been read off a real Seal contract (#855). A cadence we can prove, a
     renewal price we cannot, and the honest version says only the first. */
  const subTerms = (tierKey, sub) => {
    const t = TIERS[tierKey];
    const ships = t.tubes === 1 ? 'ships' : 'ship';
    const price = SUB_TERMS_PRICE ? ` at ${money(tierTotal(tierKey, sub))}` : '';
    return `${tubeWord(t.tubes)} ${ships} today, then ${tubeWord(t.tubes)} ` +
           `${planFor(tierKey).label}${price}. Skip, delay or cancel any time before the next charge.`;
  };

  const perTube = (tierKey, sub) =>
    Math.round(tierTotal(tierKey, sub) / TIERS[tierKey].tubes);

  /* THE single add-to-cart payload, for VYDrawer.add().

     One variant, quantity 1, plus the tier's own selling plan when she is
     subscribing. That is the whole thing. There is no quantity trick and no
     app property, because the variant IS the bundle now and Shopify prices it
     without help.

     It throws rather than degrading while variantId is null. A payload that
     silently fell back to {serum, quantity: tubes} would rebuild the exact
     bug this file was rewritten to delete: the cart would charge per tube and
     the buybox would keep advertising the bundle price. */
  const addPayload = state => {
    const key = state.tier;
    const t = TIERS[key];
    const plan = planFor(key);

    if (!t.variantId) {
      throw new Error(
        `VY_OFFER: tier ${key} has no variantId. The bundle variants are not ` +
        `on the product yet (omar-os #943). Refusing to add to cart rather ` +
        `than fall back to a quantity add, which the cart would price per tube.`);
    }

    /* state.zone is optional. The PDP asks her where she is thinning, so the
       answer rides along as a line property and support knows where to aim the
       routine card. The homepage does not ask, and a homepage that stamps
       "Hairline" on the order because that is the default is telling support
       something the customer never said. No picker, no property. */
    const zone = state.zone ? ZONES[state.zone] : null;

    const item = {
      id: t.variantId,
      quantity: 1,
      /* Display hints for the prototype drawer, ignored by Shopify. unitCents
         is the whole tier price because the line IS one bundle. No lineCents
         override any more: with a real variant Shopify's own line total is
         right, and an override would also stop two adds of the same tier from
         merging the way a shopper expects. */
      unitCents: tierTotal(key, state.sub),
      meta: zone ? `${zone.label} · ${t.label}` : t.label,
      planLabel: state.sub ? plan.label : undefined
    };
    if (zone) item.properties = { _zone: zone.label };
    if (state.sub && plan.id) item.selling_plan = plan.id;
    return [item];
  };

  /* Is the top of the ladder actually the best deal? Both surfaces say so out
     loud when it is not, and both recompute it here rather than trusting
     their own copy, so the admission disappears by itself the day the client
     reprices. Reads TIER_ORDER rather than naming keys, so a ladder change
     cannot leave it comparing two tiers that no longer exist. */
  const TOP_TIER    = TIER_ORDER[TIER_ORDER.length - 1];
  const RUNNER_UP   = TIER_ORDER[TIER_ORDER.length - 2];
  const topIsWorseValue = sub => perTube(TOP_TIER, sub) >= perTube(RUNNER_UP, sub);

  /* The sentence itself, built from the numbers rather than typed into the
     markup. It was typed into the markup, and it sat there quoting $15.06
     against $14.99 from a ladder that no longer existed. */
  const topValueNote = sub =>
    `${TIERS[TOP_TIER].cardTitle} works out at ${money(perTube(TOP_TIER, sub))} a tube against ` +
    `${money(perTube(RUNNER_UP, sub))} on ${TIERS[RUNNER_UP].cardTitle}. You are buying more cover, ` +
    `not a deeper discount.`;

  /* Old name, still read by the homepage until it is rewritten (omar-os
     #946). Same function, no second implementation to drift. */
  const tier3IsWorseValue = topIsWorseValue;

  /* The comparison table's per-tube claim. COMPUTED, not typed. It used to be
     the string "$18.74 a tube on the four-tube offer", which went stale at the
     2026-08-04 repricing and stayed wrong on both surfaces for four days
     because a hardcoded price cannot notice that the ladder moved. */
  const costClaim = sub =>
    `${money(perTube(TOP_TIER, sub))} a tube on the ${TIERS[TOP_TIER].tubes}-tube offer`;
  const COST_CLAIM = costClaim(SUB_DEFAULT);

  window.VY_OFFER = {
    PRODUCT_ID, SERUM, SUB, SUB_ENABLED, SUB_DEFAULT, SUB_TERMS_PRICE,
    TIERS, TIER_ORDER, TIER_DEFAULT, TOP_TIER, RUNNER_UP,
    ZONES, ZONE_DEFAULT, COST_CLAIM, PRODUCT_URL,
    money, planFor, subCents, tierTotal, perTube, subTerms, shipEvery, addPayload,
    topIsWorseValue, topValueNote, tier3IsWorseValue, costClaim
  };
})();
